import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    // Wait for exit animation (0.3s) to finish before scrolling
    const timer = setTimeout(() => window.scrollTo(0, 0), 350);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};
export default ScrollToTop;
